/**
 * CargaFoto
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {Carga} from '@/model/resource/Carga'
import {CargaFotoCollection} from '@/model/collection/CargaFotoCollection'

/* TODO: review generated class */
export class CargaFoto extends Resource {
  idFotoPk: number = 0

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  urlImagem: string | null = null
  ehOcorrencia: boolean | null = null
  reprocessar: boolean | null = null

  urlBackup: string | null = null

  get $id() {
    return this.idFotoPk
  }
  set $id(val) {
    this.idFotoPk = val
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(val) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = val
  }

  /**
   * Gets a instance of a given ID of CargaFoto
   */
  async getCargaFoto(id: number) {
    return await Request.get(`/admin/carga-foto/${id}`)
      .name('getCargaFoto')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of CargaFoto
   */
  static async listCargaFoto(params: any) {
    return await Request.get(`/admin/carga-foto`, {params})
      .name('listCargaFoto')
      .as(CargaFotoCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaFoto. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaFoto() {
    return await Request.post(`/admin/carga-foto`, this)
      .name('persistCargaFoto')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaFoto to use it in a CSV file
   */
  static async listCsvCargaFoto(params: any) {
    return await Request.get(`/admin/carga-foto/csv`, {params})
      .name('listCsvCargaFoto')
      .as(CargaFotoCollection)
      .getData()
  }
}
